module.exports = __webpack_public_path__ + "img/close.559172fa.svg";